import MapContainer, { MAP_STYLES } from '@components/map/Map';
import { type FC, useMemo, useRef } from 'react';
import { type MapRef } from 'react-map-gl';
import Skeleton from 'react-loading-skeleton';
import { CardContainer } from 'layout/Card';
// import { SingleSelectInput } from '@components/inputs/SelectInput/SingleSelectInput';
import CustomMarkerWithTooltip from './CustomMarkerWithTooltip';
import { useFetchOrganizationMap } from 'api/organization/organizationServices';

const OrganizationViewMap: FC = () => {
  const mapRef = useRef<MapRef | null>(null);
  const mapContainerRef = useRef(null);
  const { data, isFetching } = useFetchOrganizationMap();

  const coordinates = useMemo(() => {
    if (data && data?.length > 0) {
      return data.map((building) => [building.longitude, building.latitude]);
    }
    return [];
  }, [data]);

  const isSingleBuilding = useMemo(() => {
    return data && data?.length === 1;
  }, [data]);

  const initialViewState = useMemo(() => {
    if (isSingleBuilding && data) {
      return {
        latitude: data[0].latitude,
        longitude: data[0].longitude,
        pitch: 50,
        bearing: 15,
        zoom: 17,
      };
    }
    return {
      latitude: 50.5039,
      longitude: 4.4699,
      zoom: 7,
    };
  }, [data, isSingleBuilding]);

  return (
    <CardContainer>
      <div className="flex flex-col flex-1 gap-3">
        {/* <div className="flex items-center justify-end">
          <SingleSelectInput
            options={[]}
            maxWidth="250px"
            placeholder="Showing all groups"
            disabled={true}
          />
        </div> */}
        {isFetching ? (
          <Skeleton height={400} containerClassName="flex-1" />
        ) : (
          <div
            ref={mapContainerRef}
            className="relative"
            style={{ height: 400 }}
          >
            <MapContainer
              ref={mapRef}
              coordinates={coordinates}
              height={400}
              mapStyle={MAP_STYLES.streets}
              fitBounds={true}
              initialViewState={initialViewState}
            >
              {data?.map((building) => {
                return (
                  <CustomMarkerWithTooltip
                    key={building.name}
                    longitude={building.longitude}
                    latitude={building.latitude}
                    name={building.name}
                    tags={building?.tags}
                    needsAttention={building?.needs_attention}
                    assetId={building.asset_id}
                    mapRef={mapRef}
                    mapContainerRef={mapContainerRef}
                  />
                );
              })}
            </MapContainer>
          </div>
        )}
      </div>
    </CardContainer>
  );
};

export default OrganizationViewMap;
